/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeCircleMOffIcon16Solid = forwardRef('ShapeCircleMOffIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.207 1.793A1 1 0 0 0 .793 3.207L2.725 5.14a6 6 0 0 0 8.136 8.136l1.932 1.932a1 1 0 0 0 1.414-1.414l-12-12Z" }),
        React.createElement("path", { d: "M14 8a5.972 5.972 0 0 1-.766 2.936l-8.17-8.17A6 6 0 0 1 14 8Z" })));
});
